import React from 'react';
import styled from 'styled-components';

const LoaderRoot = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'mainLoader',
})<{ mainLoader?: boolean }>`
  position: ${(props) => (props.mainLoader ? 'fixed' : 'relative')};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #00968f;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export interface LoaderProps {
  mainLoader?: boolean;
}

const Loader = ({ mainLoader }: LoaderProps) => (
  <LoaderRoot mainLoader={mainLoader}>
    <Spinner />
  </LoaderRoot>
);

export default Loader;
